import {
  each,
  filter,
  remove,
  map,
  find
} from 'lodash';
import app from '../../angular_app.es6';
import remoteFiles from '../../../approach-react/common/remote_files';
import { waitingForMessage } from '../../../approach-react/express/admin/adcept/detailsCustomText/controllerMessaging';
import { addAttributeMethodsToScope } from './helpers/attributes_helper.es6';
import { customMetricsChanged } from './helpers/custom_metrics_helper.es6';

app.controller('DetailsAdceptController', [ '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope',
  ($scope, Notification, $timeout, $http, $element, $interval, $rootScope) => {
    $scope.form = {};
    $scope.source_form = {};
    $scope.options = {};
    $scope.checkInterval = 5000;
    $scope.checkEvery5s = null;

    $scope.state = {
      brandError: false,
      gridError: false
    };

    $scope.init = (data, options, notification, errors) => {
      data.buzzback = options.buzzback;
      $scope.form = angular.copy(data);
      // Connection to angular from react to change custom text
      const destroyWaiting = waitingForMessage(
        $timeout,
        (data) => {
          const { dmMetricName, fieldName, fieldValue } = data;
          const metricByDm = find(
            $scope.form.express_metrics,
            (el) => (el.default_metric?.name === dmMetricName)
          );
          metricByDm[fieldName] = fieldValue;
        }
      );
      $scope.$on(
        "$destroy", () => { destroyWaiting(); }
      );

      $scope.source_form = data;
      $scope.options = options;
      $scope.notification = notification;
      $scope.asyncGenerateJID = $scope.options.jid;

      if ($scope.asyncGenerateJID) {
        $scope.checkEvery5s = $interval($scope.checkAsyncGenerate, $scope.checkInterval);
        $rootScope.$broadcast('disableNavButtons');
      }

      $scope.errors = errors;
      if ($scope.errors && $scope.errors['express_metrics.brand_name']) {
        $scope.state.brandError = true;
      }
      if ($scope.errors && $scope.errors['express_metrics.grid_items.question']) {
        $scope.state.gridError = true;
      }

      if ($scope.notification) {
        Notification.error($scope.notification);
      }

      $scope.$watch('form.preference_enabled', (newValue, oldValue) => {
        if (oldValue !== newValue && !newValue) {
          $scope.form.preference_reasons = false;
        }
      });
      $scope.images = remoteFiles.express.steps.adcept;
      $scope.packageImages = remoteFiles.express.steps.package.tooltips;
      addAttributeMethodsToScope($scope);
    };

    $scope.actualGridItems = (metric) => (filter(metric.grid_items, (item) => !item._destroy));

    $scope.getGridIndexFromMetric = (metric) => {
      const grids = filter(
        $scope.form.express_metrics,
        (el) => !!$scope.actualGridItems(el).length
      );
      return grids.indexOf(metric);
    };

    $scope.gridNameCopy = (metric) => {
      const gridIndex = $scope.getGridIndexFromMetric(metric);
      if (gridIndex === -1) {
        return metric.default_metric_title.toLowerCase();
      }
      return $scope.options.grids_copy.names[gridIndex];
    };

    $scope.gridDescriptionCopy = (metric) => {
      const gridIndex = $scope.getGridIndexFromMetric(metric);
      if (gridIndex === -1) {
        return '';
      }
      return $scope.options.grids_copy.descriptions[gridIndex];
    };

    $scope.gridItemCopy = (metric, gridItemIndex, item) => {
      const gridIndex = $scope.getGridIndexFromMetric(metric);
      return $scope.options.grids_copy.items[gridIndex][gridItemIndex] || item.question;
    };

    $scope.isGrid = (metric) => (metric.metric_kind === "grid" && !metric.hidden);

    $scope.isSingle = (metric) => (metric.metric_kind === "single" && !metric.hidden);

    $scope.isMonadic = () => ($scope.form.concepts_mode === "monadic");

    $scope.gridOnlyItems = () => filter($scope.form.express_metrics, (el) => $scope.isGrid(el));

    $scope.indexByMetric = (metric) => $scope.form.express_metrics.indexOf(metric);

    $scope.gridIndexes = () => map($scope.gridOnlyItems(), (el) => $scope.indexByMetric(el));

    $scope.canAddItem = (metric) => {
      const editableCnt = filter(
        $scope.actualGridItems(metric),
        (item) => item.editable
      ).length;
      const selectedCnt = filter(
        $scope.actualGridItems(metric),
        (item) => (!item.editable && item.enabled)
      ).length;

      return (editableCnt + selectedCnt) < $scope.options.max_items;
    };

    $scope.canAddSingleItem = () => {
      const selectedCnt = filter(
        $scope.form.express_metrics,
        (item) => ($scope.isSingle(item) && item.enabled)
      ).length;
      return selectedCnt < $scope.options.max_single_items;
    };

    $scope.canAddN = (metric) => {
      const selectedCnt = filter(
        $scope.actualGridItems(metric),
        (item) => (!item.editable && item.enabled)
      ).length;

      return $scope.options.max_items - selectedCnt;
    };

    $scope.deleteItem = (event, metric, item) => {
      event.preventDefault();
      if (!item.id) {
        remove(metric.grid_items, item);
      } else {
        item._destroy = true;
      }
    };

    $scope.$watch('form.concepts_num', (newVal) => {
      if (!newVal) {
        return;
      }

      each(
        $scope.options.diagnostics_options,
        (el) => { el.enabled = (el.value <= $scope.form.concepts_num); }
      );
      if ($scope.form.concepts_num < $scope.form.diagnostics_num) {
        $scope.form.diagnostics_num = $scope.form.concepts_num;
      }
    });

    // private

    $scope.checkAsyncGenerate = () => {
      $http.get($scope.options.check_status_url).then(
        (success) => {
          if (success.data.status === "finished") {
            $interval.cancel($scope.checkEvery5s);
            $scope.asyncGenerateJID = null;
            window.location.href = $scope.options.next_step_url;
          } else if (success.data.status === "failed") {
            $scope.asyncGenerateJID = null;
            $interval.cancel($scope.checkEvery5s);
            Notification.error("Project rebuilding failed.");
            $rootScope.$broadcast('enableNavButtons');
          }
        },
        (reject) => {
          $interval.cancel($scope.checkEvery5s);
          $scope.asyncGenerateJID = null;
          console.log('checkAsyncGenerate', reject);
          $rootScope.$broadcast('enableNavButtons');
        }
      );
    };

    $scope.$on('project-form-next-step', (event) => {
      each(
        filter($scope.form.express_metrics, (item) => $scope.isGrid(item)),
        (metric) => {
          const enabledItemsCount = filter(
            $scope.actualGridItems(metric),
            (item) => item.enabled
          ).length;
          if (!enabledItemsCount) {
            metric.enabled = false;
          }
        });

      if ($scope.asyncGenerateJID) {
        event.preventDefault();
        Notification.error("Rebuilding in progress.");
        return;
      }

      const changesPresent = trackChanges() || customMetricsChanged();
      const form = $('#details_form');

      if (!$scope.options.need_generate || !$scope.options.is_valid) {
        form.submit();
      } else if (!changesPresent && !$scope.notification) {
        event.preventDefault();
        window.location.href = $scope.options.next_step_url;
      } else if (confirm($scope.options.change_structure_message)) {
        form.submit();
      }
    });

    const trackChanges = () => (!angular.equals($scope.form, $scope.source_form));
  } ]);
